var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 12.9H6.9C6.645 12.9 6.43125 12.8142 6.25875 12.6427C6.08625 12.4713 6 12.2587 6 12.0052C6 11.7517 6.08625 11.5375 6.25875 11.3625C6.43125 11.1875 6.645 11.1 6.9 11.1H11.1V6.9C11.1 6.645 11.1858 6.43125 11.3573 6.25875C11.5288 6.08625 11.7413 6 11.9948 6C12.2483 6 12.4625 6.08625 12.6375 6.25875C12.8125 6.43125 12.9 6.645 12.9 6.9V11.1H17.1C17.355 11.1 17.5688 11.1858 17.7413 11.3573C17.9138 11.5288 18 11.7413 18 11.9948C18 12.2483 17.9138 12.4625 17.7413 12.6375C17.5688 12.8125 17.355 12.9 17.1 12.9H12.9V17.1C12.9 17.355 12.8142 17.5688 12.6427 17.7413C12.4713 17.9137 12.2587 18 12.0052 18C11.7517 18 11.5375 17.9137 11.3625 17.7413C11.1875 17.5688 11.1 17.355 11.1 17.1V12.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserIcon);
export default __webpack_public_path__ + "static/media/AddUserIcon.a0a12f0afbabe0ecabb4c24dff062be5.svg";
export { ForwardRef as ReactComponent };